import { Dispatch, FC, Fragment, SetStateAction, useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { useWindowSize } from '../../hooks';
import Button from './Button';
import Flex from './Flex';
import MoreVerticalMenu from './MoreVerticalMenu';

export type ActionButtonType = {
  bg?: string;
  icon?: JSX.Element;
  label: string;
  to?: string;
  hide?: boolean;
  disabled?: boolean;
  clickAction?: () => void;
  tooltip?: string;
  tooltipId?: string;
};

type ActionButtonsProps = {
  id: string;
  actions: ActionButtonType[];
  popoverVisibility: {};
  setPopoverVisibility: Dispatch<SetStateAction<{}>>;
};

const ActionButtons: FC<ActionButtonsProps> = props => {
  const [width] = useWindowSize();
  const [actionsCount, setActionsCount] = useState(0);

  useEffect(() => {
    const screenSizeReference = {
      extraLarge: 2,
      large: 1,
      small: 0,
      tablet: 0,
      mobile: 0,
    };
    const sizes = {
      mobile: Boolean(width < 480),
      tablet: Boolean(width > 480 && width < 780),
      small: Boolean(width > 780 && width < 1024),
      large: Boolean(width > 1024 && width < 1280),
      extraLarge: Boolean(width > 1280 || width === 1280),
    };
    const truthySize = Object.keys(sizes).filter(key => sizes[key] === true);

    setActionsCount(screenSizeReference[truthySize[0]]);
  }, [width]);

  return (
    <Flex direction="row" size="1" justify="flex-end" alignItems="center">
      <Fragment>
        {props.actions.slice(0, actionsCount).map((action, index) => {
          return (
            !action.hide && (
              <Fragment key={index}>
                <span data-tip={true} data-for={action.tooltipId}>
                  <Button
                    bg={action.bg}
                    icon={action.icon}
                    isIcon={true}
                    mr={1}
                    p={0}
                    disabled={action.disabled === true}
                    type="button"
                    width="40px"
                    onClick={action.clickAction}
                  />
                </span>
                {action.tooltipId && (
                  <ReactTooltip id={action.tooltipId} effect="solid">
                    {action.label}
                  </ReactTooltip>
                )}
              </Fragment>
            )
          );
        })}
        {Boolean(props.actions.slice(actionsCount).length) && (
          <MoreVerticalMenu
            id={props.id}
            menus={props.actions.slice(actionsCount)}
            popoverVisibility={props.popoverVisibility}
            setPopoverVisibility={props.setPopoverVisibility}
          />
        )}
      </Fragment>
    </Flex>
  );
};

export default ActionButtons;
